<template>
    <div class="nav-float" v-show="displayNavigationButtons">
        <div class="d-flex align-items-center justify-content-center h-100">
            <BtnNavigation
                v-if="displayTask || displayComment"
                @click.native="whenClickButton('responses')"
                :label="$t('polls.btnPolls')"
                :icon="['fas', 'check']"
                :count="answersCount"
            />
            <BtnNavigation
                v-if="displayTask"
                @click.native="whenClickButton('tasks')"
                :label="$t('tasks.btnJobs')"
                :icon="['far', 'calendar-check']"
                :count="poll.tasks.length"
            />
            <BtnNavigation
                v-show="displayComment"
                @click.native="whenClickButton('comments')"
                :label="$t('comments.btnComments')"
                :icon="['far', 'comment-dots']"
                :count="commentsCount"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { renderMixin } from '../mixins/RenderMixins';

export default {
  name: 'NavigationButtons',
  props: {
    displayTask: {
        type: Boolean,
        default: false
    },
    displayComment: {
        type: Boolean,
        default: false
    },
    displayNavigationButtons: {
        type: Boolean,
        default: false
    }
  },
  mixins: [
    renderMixin
  ],
  computed: {
    ...mapState({
      poll: (state) => state.poll.poll
    })
  },
  methods: {
    whenClickButton(type) {
        this.$emit('whenClicked', type);
    }
  }
};
</script>
